import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSizeFormatter'
})
export class FileSizeFormatterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let v:any;
    if(value/(1024*1024) > 1) {
      v = parseFloat((value/(1024*1024)).toString()).toFixed(1);
      v = (v.split('.')[1] == 0 ? v.split('.')[0] : v) + "MB";
    } else {
      v = parseFloat((value/(1024)).toString()).toFixed(1);
      v = (v.split('.')[1] == 0 ? v.split('.')[0] : v) + "KB";
    }
    return v;
  }

}



// WEBPACK FOOTER //
// ./public/app/_pipes/file-size-formatter.pipe.ts